<app-menu-crud-panel-top [rows]="recordRowsLogs" [conf]="recordConfBtns" [toggle]="layoutAsToggle">

</app-menu-crud-panel-top>